import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import axios from 'axios';


const CommunityBlock = styled.div`
    border-top:107px solid orange;
    padding:100px 0;
    .row {
        h2 { text-align:center; font-size:30px }
        ul {
            display:flex;
            flex-wrap:wrap;
            li { width:25%; margin:20px 0}
        }
    }
`;

const Communitysection = () => {

    const [cleanair, setCleanair] = useState([])

    const getAir = async () => {
        const kim = await axios.get('https://hoon-app.herokuapp.com/http://apis.data.go.kr/B552584/UlfptcaAlarmInqireSvc/getUlfptcaAlarmInfo?serviceKey=pNZNuvClDud4lVGs%2Fh78SAbJoLxQtKXFPxOcIOWJ7pvbIDvUj83ArMz1qQ%2FkR4v48f7392SFMGM5F8Ojwx7Y5Q%3D%3D&returnType=json&numOfRows=100&pageNo=1&year=2020&itemCode=PM10')
        console.log(kim)
        setCleanair(kim.data.response.body.items)    
   }    


    useEffect( ()=>{
        getAir()
    }, [cleanair] )

    return (
        <CommunityBlock>
            <div className="row">
                <h2>에어코리아 미세먼지 경고발령현황</h2>
                <ul>
                    { cleanair && cleanair.map( (data, index) => <li key={index}>{data.districtName} : {data.issueVal}</li> ) }
                  
                </ul>
            </div>
        </CommunityBlock>
    );
};

export default Communitysection;